import { BetonOrderCalcParams, BetonOrderCalcResult, BetonOrderFormInitialData, BetonOrderParams } from '@beton/const';
import { HttpErrorModel, StateUtils } from '@spartacus/core';
import { BETON_ORDER_CALCULATION, BETON_ORDER_CONFIRMATION, BETON_ORDER_INITIALIZATION } from '../beton-state';

export const LOAD_BETON_ORDER_INITIAL_DATA = '[Beton] Load beton order initial data';
export const LOAD_BETON_ORDER_INITIAL_DATA_SUCCESS = '[Beton] Load beton order initial data success';
export const LOAD_BETON_ORDER_INITIAL_DATA_FAIL = '[Beton] Load beton order initial data fail';
export const RESET_BETON_ORDER_INITIAL_DATA = '[Beton] Reset beton order initial data';

export const CALCULATE_BETON_ORDER = '[Beton] Calculate beton order';
export const CALCULATE_BETON_ORDER_SUCCESS = '[Beton] Calculate beton order success';
export const CALCULATE_BETON_ORDER_FAIL = '[Beton] Calculate beton order fail';
export const RESET_BETON_ORDER_CALC_DATA = '[Beton] Reset beton order calc data';

export const CONFIRM_BETON_ORDER = '[Beton] Confirm beton order';
export const CONFIRM_BETON_ORDER_SUCCESS = '[Beton] Confirm beton order success';
export const CONFIRM_BETON_ORDER_FAIL = '[Beton] Confirm beton order fail';
export const RESET_BETON_ORDER_CONFIRM_DATA = '[Beton] Reset beton order confirm data';

export class LoadBetonOrderInitialData extends StateUtils.LoaderLoadAction {
  readonly type = LOAD_BETON_ORDER_INITIAL_DATA;

  constructor() {
    super(BETON_ORDER_INITIALIZATION);
  }
}

export class LoadBetonOrderInitialDataSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = LOAD_BETON_ORDER_INITIAL_DATA_SUCCESS;

  constructor(public payload: BetonOrderFormInitialData) {
    super(BETON_ORDER_INITIALIZATION);
  }
}

export class LoadBetonOrderInitialDataFail extends StateUtils.LoaderFailAction {
  readonly type = LOAD_BETON_ORDER_INITIAL_DATA_FAIL;

  constructor() {
    super(BETON_ORDER_INITIALIZATION);
  }
}

export class ResetBetonOrderInitialData extends StateUtils.LoaderResetAction {
  readonly type = RESET_BETON_ORDER_INITIAL_DATA;

  constructor() {
    super(BETON_ORDER_INITIALIZATION);
  }
}

export class CalculateBetonOrder extends StateUtils.LoaderLoadAction {
  readonly type = CALCULATE_BETON_ORDER;

  constructor(public payload: BetonOrderCalcParams) {
    super(BETON_ORDER_CALCULATION);
  }
}

export class CalculateBetonOrderSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CALCULATE_BETON_ORDER_SUCCESS;

  constructor(public payload: BetonOrderCalcResult) {
    super(BETON_ORDER_CALCULATION);
  }
}

export class CalculateBetonOrderFail extends StateUtils.LoaderFailAction {
  readonly type = CALCULATE_BETON_ORDER_FAIL;

  constructor(public payload: HttpErrorModel) {
    super(BETON_ORDER_CALCULATION, payload);
  }
}

export class ResetBetonOrderCalcData extends StateUtils.LoaderResetAction {
  readonly type = RESET_BETON_ORDER_CALC_DATA;

  constructor() {
    super(BETON_ORDER_CALCULATION);
  }
}

export class ConfirmBetonOrder extends StateUtils.LoaderLoadAction {
  readonly type = CONFIRM_BETON_ORDER;

  constructor(public payload: BetonOrderParams) {
    super(BETON_ORDER_CONFIRMATION);
  }
}

export class ConfirmBetonOrderSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = CONFIRM_BETON_ORDER_SUCCESS;

  constructor(public payload: unknown) {
    super(BETON_ORDER_CONFIRMATION);
  }
}

export class ConfirmBetonOrderFail extends StateUtils.LoaderFailAction {
  readonly type = CONFIRM_BETON_ORDER_FAIL;

  constructor(public payload: HttpErrorModel) {
    super(BETON_ORDER_CONFIRMATION, payload);
  }
}

export class ResetBetonOrderConfirmData extends StateUtils.LoaderResetAction {
  readonly type = RESET_BETON_ORDER_CONFIRM_DATA;

  constructor() {
    super(BETON_ORDER_CONFIRMATION);
  }
}

export type BetonOrderActions =
  | LoadBetonOrderInitialData
  | LoadBetonOrderInitialDataSuccess
  | LoadBetonOrderInitialDataFail
  | ResetBetonOrderInitialData
  | CalculateBetonOrder
  | CalculateBetonOrderSuccess
  | CalculateBetonOrderFail
  | ResetBetonOrderCalcData
  | ConfirmBetonOrder
  | ConfirmBetonOrderSuccess
  | ConfirmBetonOrderFail
  | ResetBetonOrderConfirmData;
